import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: { public: true },
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: "/index",
    children: [
      {
        path: "/index",
        name: "Index",
        component: () => import("../views/index/index"),
      },
      {
        path: "/active",
        name: "Active",
        component: () => import("@/views/index/activation.vue"),
      },
      {
        path: "/orderlist",
        name: "orderlist",
        component: () => import("@/views/order/orderlist"),
      },
      {
        path: "/orderSeting",
        name: "OrderSeting",
        component: () => import("@/views/order/orderSeting"),
        redirect: "/revokeorder",
        children: [
          {
            path: "/revokeorder",
            name: "revokeorder",
            component: () => import("@/views/order/revokeorder"),
          },
          {
            path: "/orderCancelSet",
            name: "OrderCancelSet",
            component: () => import("@/views/order/order-cancel-set"),
          },
        ],
      },
      {
        path: "/riderlist",
        name: "riderlist",
        component: () => import("@/views/rider/riderlist"),
      },
      {
        path: "/rider-edit-info",
        name: "riderEditInfo",
        component: () => import("@/views/rider/rider-edit-info.vue"),
      },
      {
        path: "/riderauthentication",
        name: "riderauthentication",
        component: () => import("@/views/rider/riderauthentication"),
      },
      {
        path: "/health-toExamine",
        name: "health-toExamine",
        component: () => import("@/views/rider/health-toExamine"),
      },
      {
        path: "/riderlevel",
        name: "riderlevel",
        component: () => import("@/views/rider/riderlevel"),
      },
      {
        path: "/riderset",
        name: "riderset",
        component: () => import("@/views/rider/riderset"),
      },
      {
        path: "/riderprize",
        name: "riderprize",
        component: () => import("@/views/rider/riderprize"),
      },
      {
        path: "/storelist",
        name: "storelist",
        component: () => import("@/views/store/storelist"),
      },
      {
        path: "/storelist-info-edit",
        name: "storelistInfoEdit",
        component: () => import("@/views/store/storelist-info-edit.vue"),
      },
      {
        path: "/distributionset",
        name: "distributionset",
        component: () => import("@/views/store/distributionset"),
      },
      {
        path: "/storevalue",
        name: "storevalue",
        component: () => import("@/views/store/storevalue"),
      },
      {
        path: "/valuerule",
        name: "valuerule",
        component: () => import("@/views/store/valuerule"),
      },
      {
        path: "/versionupdate",
        name: "versionupdate",
        component: () => import("@/views/set/versionupdate"),
      },
      {
        path: "/noticemanage",
        name: "noticemanage",
        component: () => import("@/views/set/noticemanage"),
      },
      {
        path: "/noticemant",
        name: "noticemant",
        component: () => import("@/views/set/noticemant"),
      },
      {
        path: "/agreement",
        name: "agreement",
        component: () => import("@/views/set/agreement"),
      },
      {
        path: "/platformset",
        name: "platformset",
        component: () => import("@/views/set/platformset"),
      },
      {
        path: "/enclosure",
        name: "enclosure",
        component: () => import("@/views/set/enclosure"),
      },
      {
        path: "/remind",
        name: "remind",
        component: () => import("@/views/set/remind"),
      },
      {
        path: "/payment",
        name: "payment",
        component: () => import("@/views/set/payment"),
      },
      {
        path: "/IDSet",
        name: "IDSet",
        component: () => import("@/views/set/IDSet"),
      },
      {
        path: "/activeCenter",
        name: "activeCenter",
        component: () => import("@/views/plugin/activeCenter"),
      },
      {
        path: "/applicationlist",
        name: "applicationlist",
        component: () => import("@/views/plugin/applicationlist"),
      },
      {
        path: "/appSet",
        name: "AppSet",
        component: () => import("@/views/plugin/appSet"),
      },
      {
        path: "/miniappSet",
        name: "MiniAppSet",
        component: () => import("@/views/plugin/miniappSet"),
      },
      {
        path: "/train",
        name: "train",
        component: () => import("@/views/plugin/train"),
      },
      {
        path: "/exercise",
        name: "exercise",
        component: () => import("@/views/plugin/exercise"),
      },
      {
        path: "/exerciseDetail",
        name: "exerciseDetail",
        component: () => import("@/views/plugin/exerciseDetail"),
      },
      {
        path: "/learnings",
        name: "learnings",
        component: () => import("@/views/plugin/learnings"),
      },
      {
        path: "/learningsAdd",
        name: "LearningsAdd",
        component: () => import("@/views/plugin/learnings-add.vue"),
      },
      {
        path: "/classifylist",
        name: "classifylist",
        component: () => import("@/views/plugin/classifylist"),
      },
      {
        path: "/appointment",
        name: "appointment",
        component: () => import("@/views/plugin/appointment"),
      },
      {
        path: "/rankinglist",
        name: "rankinglist",
        component: () => import("@/views/plugin/rankinglist"),
      },
      {
        path: "/bondlist",
        name: "bondlist",
        component: () => import("@/views/plugin/bondlist"),
      },
      {
        path: "/bondSet",
        name: "bondSet",
        component: () => import("@/views/plugin/bondSet"),
      },
      {
        path: "/riderfenxi",
        name: "riderfenxi",
        component: () => import("@/views/data/riderfenxi"),
      },
      {
        path: "/orderfenxi",
        name: "orderfenxi",
        component: () => import("@/views/data/orderfenxi"),
      },
      {
        path: "/riderzl",
        name: "riderzl",
        component: () => import("@/views/finance/riderzl"),
      },
      {
        path: "/riderzc",
        name: "riderzc",
        component: () => import("@/views/finance/riderzc"),
      },
      {
        path: "/shopzc",
        name: "shopzc",
        component: () => import("@/views/finance/shopzc"),
      },
      {
        path: "/withdrawalList",
        name: "withdrawalList",
        component: () => import("@/views/finance/withdrawalList"),
      },
      {
        path: "/withdrawalSet",
        name: "withdrawalSet",
        component: () => import("@/views/finance/withdrawalSet"),
      },
      {
        path: "/appletlist",
        name: "Appletlist",
        component: () => import("@/views/jurisdiction/appletlist.vue"),
      },
      {
        path: "/Appletlistedit",
        name: "Appletlistedit",
        component: () => import("@/views/jurisdiction/appletlistedit.vue"),
      },
      {
        path: "/AppletlisteditCopy",
        name: "AppletlisteditCopy",
        component: () => import("@/views/jurisdiction/appletlisteditCopy.vue"),
      },
      {
        path: "/empower",
        name: "Empower",
        component: () => import("@/views/jurisdiction/empower.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
